import { render, staticRenderFns } from "./DForm.vue?vue&type=template&id=2ba5726e"
import script from "./DForm.vue?vue&type=script&lang=ts"
export * from "./DForm.vue?vue&type=script&lang=ts"
import style0 from "./DForm.vue?vue&type=style&index=0&id=2ba5726e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports